import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

import { SwiperSlidesComponent } from '@common/swiper/swiper-slides.component';
import { SlideItem } from '@common/swiper/model';
import { ImageLoadingComponent } from '@common/image-loading/image-loading.component';
import { FocusRemoverDirective } from '@helper/focus-remover.directive';

interface IDialogData {
  index: number;
  urls: SlideItem[];
  galleryHeight: number;
  ratio: number;
  height: number;
  width: number;
}

@Component({
  selector: 'app-product-gallery',
  templateUrl: './product-gallery.component.html',
  styleUrls: ['./product-gallery.component.scss'],
  imports: [SwiperSlidesComponent, ImageLoadingComponent, MatDialogModule, FocusRemoverDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductGalleryComponent {
  static maxSize = 760;
  static minSize = 45;

  public data: IDialogData = inject(MAT_DIALOG_DATA);

  static open(
    dialog: MatDialog,
    index: number,
    urls: string[],
    galleryHeight: number,
    ratio: number = 1
  ): MatDialogRef<ProductGalleryComponent> {
    let width = galleryHeight * ratio;
    let height = galleryHeight;
    if (width > height) {
      width = Math.min(ProductGalleryComponent.maxSize, width);
      height = width / ratio;
    } else {
      height = Math.min(ProductGalleryComponent.maxSize, height);
      width = height * ratio;
    }
    const data: IDialogData = {
      index: index ?? 0,
      urls: urls.map(url => new SlideItem(url, '', '')),
      galleryHeight,
      ratio,
      height: Math.max(height, ProductGalleryComponent.minSize),
      width: Math.max(width, ProductGalleryComponent.minSize),
    };
    const padding = 10;
    return dialog.open(ProductGalleryComponent, {
      height: `${height + padding}px`,
      width: `${width + padding}px`,
      panelClass: 'no-radius-dialog',
      data,
    });
  }
}
